import React from 'react';
import Info from '../../icons/info.svg';

export const InfoIcon = () => <img src={Info} alt='More info' style={{ height: '20px', width: '20px' }} />;
